function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 10V7.7C20 6.5799 20 6.01984 19.782 5.59202C19.5903 5.2157 19.2843 4.90974 18.908 4.71799C18.4802 4.5 17.9201 4.5 16.8 4.5H5.2C4.0799 4.5 3.51984 4.5 3.09202 4.71799C2.7157 4.90973 2.40973 5.21569 2.21799 5.59202C2 6.01984 2 6.5799 2 7.7V17.3C2 18.4201 2 18.9802 2.21799 19.408C2.40973 19.7843 2.71569 20.0903 3.09202 20.282C3.51984 20.5 4.07989 20.5 5.2 20.5L16.8 20.5C17.9201 20.5 18.4802 20.5 18.908 20.282C19.2843 20.0903 19.5903 19.7843 19.782 19.408C20 18.9802 20 18.4201 20 17.3V15M15 12.5C15 12.0353 15 11.803 15.0384 11.6098C15.1962 10.8164 15.8164 10.1962 16.6098 10.0384C16.803 10 17.0353 10 17.5 10H19.5C19.9647 10 20.197 10 20.3902 10.0384C21.1836 10.1962 21.8038 10.8164 21.9616 11.6098C22 11.803 22 12.0353 22 12.5C22 12.9647 22 13.197 21.9616 13.3902C21.8038 14.1836 21.1836 14.8038 20.3902 14.9616C20.197 15 19.9647 15 19.5 15H17.5C17.0353 15 16.803 15 16.6098 14.9616C15.8164 14.8038 15.1962 14.1836 15.0384 13.3902C15 13.197 15 12.9647 15 12.5Z",
  stroke: "#111927",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgWallet04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet04);
export default __webpack_public_path__ + "static/media/wallet-04.75671de9.svg";
export { ForwardRef as ReactComponent };